export default __webpack_public_path__ + "static/media/jQuery-icon.5218d846.png";